import { getDefaultSettings, getHostName, injectAgentContainer } from '../modules/utilities-preload/src/utilities-preload'

export { getDefaultSettings, getHostName, injectAgentContainer };


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/ref/utilities-preload.js